export const publicPageUrl = (language, page = 'home') => {
  const lang = language?.toLowerCase().startsWith('de') ? 'de' : 'en';
  return `/${lang}/${page === 'home' ? '' : `${page}/`}`;
};
